import { createSlice } from "@reduxjs/toolkit";
import { readImpersonationOrigin } from "../../utils/impersonationStorage";
import { logout } from "./authSlice";

// Presence + display data for the "View as" role preview banner. The source
// of truth for "are we previewing?" is the impersonation_origin localStorage
// key (stashed superuser session) — reading it at store init makes the banner
// survive a hard refresh mid-preview. Target display data is best-effort:
// after a refresh it is gone and the banner falls back to state.auth.user
// (which IS the target while previewing).
const initialState = {
  active: !!readImpersonationOrigin(),
  target: null, // { name, role } for the banner label
};

const impersonationSlice = createSlice({
  name: "impersonation",
  initialState,
  reducers: {
    impersonationStarted: (state, action) => {
      state.active = true;
      state.target = action.payload || null;
    },
    impersonationEnded: (state) => {
      state.active = false;
      state.target = null;
    },
  },
  // Logout (any dispatch site) ends the preview presence too — the auth
  // reducer clears the impersonation_origin key, this clears the in-memory
  // flag so a follow-up login can't boot with a false banner.
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.active = false;
      state.target = null;
    });
  },
});

export const { impersonationStarted, impersonationEnded } =
  impersonationSlice.actions;

export const selectImpersonationActive = (state) =>
  !!state.impersonation?.active;
export const selectImpersonationTarget = (state) =>
  state.impersonation?.target || null;

export default impersonationSlice.reducer;
